import "./gallery_hero_carousel_section_full_trio_desktop.css";
import "./gallery_hero_carousel_section_full_trio_mobile.css";
import "./gallery_hero_carousel_section_full_trio_green_theme.css";

import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
